import React from "react";
import styled from "@emotion/styled";
import mq from "../utils/mediaQueries";
import useWindowSize from "../hooks/useWindowSize";
import { breakpoints } from "../hooks/useBreakpoint";
import Cross from "./Cross";

const BasicInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${mq("md")} {
    justify-content: center;
  }
`;

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 0 0 0;

  ${mq("md")} {
    padding: 1rem 0 1rem 0;
    flex-direction: row;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 0 0 1rem 0;
  flex: 1;

  ${mq("md")} {
    padding: 1rem 0 1.5rem 0;
  }
`;

const Text = styled.p`
  font-size: 1.75rem;
  font-weight: 400;
  word-break: break-all;
`;

const CrossWrapper = styled.div`
  align-self: center;

  > svg {
    width: 50px;
    height: auto;
  }

  ${mq("sm")} {
    > svg {
      width: 50px;
      height: auto;
    }
  }
`;

const BasicInformation = ({ character }) => {
  const { width } = useWindowSize();

  return (
    <BasicInformationWrapper>
      {width < breakpoints.md && (
        <CrossWrapper>
          <Cross />
        </CrossWrapper>
      )}
      <Wrapper>
        <InfoWrapper>
          <h1>{">>> NAME <<<"}</h1>
          <Text>{character.name}</Text>
        </InfoWrapper>
        <InfoWrapper>
          <h1>
            {width < breakpoints.sm ? ">>> HP <<<" : ">>> HIT POINTS <<<"}
          </h1>
          <Text>{character.hitPoints}</Text>
        </InfoWrapper>
        <InfoWrapper>
          <h1>
            {width < breakpoints.sm ? ">>> DR <<<" : ">>> DEFENSE RATING <<<"}
          </h1>
          <Text>{character.defenseRating}</Text>
        </InfoWrapper>
      </Wrapper>
      {width < breakpoints.md && (
        <CrossWrapper>
          <Cross />
        </CrossWrapper>
      )}
    </BasicInformationWrapper>
  );
};

export default BasicInformation;
